export const START_FIXA_NASCOSTI = 'START_FIXA_NASCOSTI';

/**
 * task Fixa Nascosti.
 * @function startFixaNascosti
 * @returns {Object} Get Fixa Nascosti results action.
 */
export function startFixaNascosti() {
  return {
    type: START_FIXA_NASCOSTI,
    request: {
      op: 'get',
      path: '/@fixaNascosti',
    },
  };
}
